export default function CoursesSection() {
  const courses = [
    {
      level: '幼兒',
      title: '幼兒美語班',
      image: 'https://public.readdy.ai/ai/img_res/7057a6a0d429eeb30b4287e978fcc707.jpg',
      description: '透過遊戲學習字母與基礎單字',
      features: ['遊戲式學習', '基礎字母', '簡單會話'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '國小',
      title: '國小美語',
      image: 'https://readdy.ai/api/search-image?query=Elementary%20school%20children%20aged%207-12%20learning%20English%20in%20modern%20classroom%20with%20interactive%20whiteboard%2C%20students%20reading%20and%20writing%2C%20organized%20educational%20setting%20with%20desks%20and%20books%2C%20bright%20clean%20background%2C%20focused%20learning%20environment&width=400&height=300&seq=course-elem-eng1&orientation=landscape',
      description: '加深美語基礎並培養聽說讀寫能力',
      features: ['聽說讀寫', '文法基礎', '會話練習'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '國小',
      title: '國小數學',
      image: 'https://readdy.ai/api/search-image?query=Elementary%20school%20students%20learning%20mathematics%20with%20numbers%20and%20geometric%20shapes%2C%20children%20solving%20math%20problems%20on%20whiteboard%2C%20organized%20classroom%20with%20educational%20materials%2C%20bright%20clean%20background%2C%20focused%20study%20atmosphere&width=400&height=300&seq=course-elem-math1&orientation=landscape',
      description: '建立數學邏輯思維與解題能力',
      features: ['邏輯思考', '解題技巧', '應用題訓練'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '國小',
      title: '國小數學卓越杯',
      image: 'https://readdy.ai/api/search-image?query=Elementary%20school%20students%20participating%20in%20mathematics%20excellence%20competition%2C%20children%20solving%20advanced%20math%20problems%20with%20focus%20and%20determination%2C%20competitive%20academic%20environment%20with%20awards%20and%20certificates%2C%20bright%20clean%20background%2C%20achievement-oriented%20atmosphere&width=400&height=300&seq=course-math-excellence1&orientation=landscape',
      description: '培養數學競賽能力，挑戰卓越杯競賽',
      features: ['競賽訓練', '進階題型', '思維拓展'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '國小',
      title: '國小數學超越杯',
      image: 'https://readdy.ai/api/search-image?query=Elementary%20school%20students%20in%20advanced%20mathematics%20competition%20preparation%2C%20children%20working%20on%20challenging%20math%20olympiad%20problems%2C%20elite%20academic%20training%20environment%20with%20mathematical%20formulas%20and%20diagrams%2C%20bright%20clean%20background%2C%20intensive%20learning%20atmosphere&width=400&height=300&seq=course-math-beyond1&orientation=landscape',
      description: '超越杯數學競賽專業培訓課程',
      features: ['奧數訓練', '超越挑戰', '菁英培育'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '國小',
      title: '國小自然',
      image: 'https://readdy.ai/api/search-image?query=Elementary%20school%20children%20learning%20science%20with%20microscopes%20and%20experiment%20tools%2C%20students%20observing%20nature%20specimens%2C%20modern%20science%20classroom%20with%20educational%20equipment%2C%20bright%20clean%20background%2C%20curious%20learning%20atmosphere&width=400&height=300&seq=course-elem-sci1&orientation=landscape',
      description: '培養科學探索精神與實驗能力',
      features: ['實驗操作', '科學觀察', '邏輯推理'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '國小',
      title: '課後安親班',
      image: 'https://readdy.ai/api/search-image?query=After%20school%20care%20program%20with%20children%20doing%20homework%20and%20studying%2C%20teacher%20helping%20students%20in%20warm%20caring%20environment%2C%20organized%20study%20area%20with%20desks%20and%20educational%20materials%2C%20bright%20clean%20background%2C%20comfortable%20learning%20space&width=400&height=300&seq=course-afterschool1&orientation=landscape',
      description: '提供完善的課後照顧與作業輔導',
      features: ['作業輔導', '美語加強', '生活照顧'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '國小',
      title: '私中菁英安親班',
      image: 'https://readdy.ai/api/search-image?query=Elite%20after%20school%20program%20for%20private%20junior%20high%20school%20preparation%2C%20students%20studying%20advanced%20materials%20with%20focused%20teachers%2C%20premium%20educational%20environment%20with%20quality%20learning%20materials%2C%20bright%20clean%20background%2C%20serious%20academic%20atmosphere&width=400&height=300&seq=course-elite1&orientation=landscape',
      description: '針對私中入學考試的專業輔導',
      features: ['私中考試', '菁英培訓', '升學輔導'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '假期',
      title: '夏/冬令營課程',
      image: 'https://readdy.ai/api/search-image?query=Summer%20and%20winter%20camp%20activities%20for%20children%2C%20kids%20participating%20in%20educational%20games%20and%20group%20activities%2C%20colorful%20fun%20environment%20with%20counselors%2C%20bright%20clean%20background%2C%20happy%20children%20learning%20together&width=400&height=300&seq=course-camp1&orientation=landscape',
      description: '寒暑假期間的主題營隊活動',
      features: ['主題活動', '戶外教學', '團體合作'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '檢定',
      title: '劍橋英檢班',
      image: 'https://readdy.ai/api/search-image?query=Cambridge%20English%20exam%20preparation%20class%20with%20students%20studying%20test%20materials%2C%20organized%20classroom%20with%20exam%20practice%20books%2C%20professional%20educational%20setting%2C%20bright%20clean%20background%2C%20focused%20test%20preparation%20atmosphere&width=400&height=300&seq=course-cambridge1&orientation=landscape',
      description: '劍橋英語認證考試專業輔導',
      features: ['考試技巧', '模擬測驗', '證書取得'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '檢定',
      title: '全民英檢班',
      image: 'https://readdy.ai/api/search-image?query=GEPT%20English%20proficiency%20test%20preparation%20with%20students%20practicing%20listening%20and%20reading%2C%20modern%20classroom%20with%20test%20materials%20and%20audio%20equipment%2C%20bright%20clean%20background%2C%20serious%20exam%20preparation%20environment&width=400&height=300&seq=course-gept1&orientation=landscape',
      description: '全民英語能力分級檢定測驗輔導',
      features: ['分級輔導', '聽說讀寫', '檢定通過'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '國中',
      title: '國中數學班',
      image: 'https://readdy.ai/api/search-image?query=Junior%20high%20school%20students%20learning%20advanced%20mathematics%2C%20teenagers%20solving%20algebra%20and%20geometry%20problems%20on%20whiteboard%2C%20organized%20classroom%20with%20textbooks%2C%20bright%20clean%20background%2C%20focused%20academic%20atmosphere&width=400&height=300&seq=course-junior-math1&orientation=landscape',
      description: '強化數學概念與會考準備',
      features: ['代數幾何', '會考準備', '解題訓練'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '國中',
      title: '國中英文班',
      image: 'https://readdy.ai/api/search-image?query=Junior%20high%20school%20English%20class%20with%20teenagers%20reading%20and%20writing%2C%20students%20practicing%20grammar%20and%20vocabulary%2C%20modern%20classroom%20with%20educational%20materials%2C%20bright%20clean%20background%2C%20serious%20learning%20environment&width=400&height=300&seq=course-junior-eng1&orientation=landscape',
      description: '提升英文能力與會考成績',
      features: ['文法精進', '閱讀理解', '寫作訓練'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '國中',
      title: '國中理化班',
      image: 'https://readdy.ai/api/search-image?query=Junior%20high%20school%20physics%20and%20chemistry%20class%20with%20teenagers%20doing%20experiments%2C%20students%20learning%20with%20lab%20equipment%20and%20scientific%20instruments%2C%20modern%20science%20classroom%2C%20bright%20clean%20background%2C%20educational%20laboratory%20atmosphere&width=400&height=300&seq=course-junior-sci1&orientation=landscape',
      description: '理化觀念建立與實驗操作',
      features: ['物理化學', '實驗課程', '會考衝刺'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '國中',
      title: '國三總複習班',
      image: 'https://readdy.ai/api/search-image?query=Ninth%20grade%20comprehensive%20review%20class%20with%20students%20preparing%20for%20high%20school%20entrance%20exam%2C%20teenagers%20studying%20intensively%20with%20practice%20tests%2C%20organized%20classroom%20with%20exam%20materials%2C%20bright%20clean%20background%2C%20serious%20exam%20preparation%20atmosphere&width=400&height=300&seq=course-junior-review1&orientation=landscape',
      description: '會考前的全科總複習與衝刺',
      features: ['全科複習', '模擬考試', '考前衝刺'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '高中',
      title: '高中數學班',
      image: 'https://readdy.ai/api/search-image?query=High%20school%20advanced%20mathematics%20class%20with%20students%20learning%20calculus%20and%20advanced%20algebra%2C%20teenagers%20solving%20complex%20math%20problems%2C%20modern%20classroom%20with%20whiteboards%2C%20bright%20clean%20background%2C%20focused%20academic%20environment&width=400&height=300&seq=course-senior-math1&orientation=landscape',
      description: '高中數學進階課程與學測準備',
      features: ['微積分', '學測準備', '進階解題'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '高中',
      title: '高中英文班',
      image: 'https://readdy.ai/api/search-image?query=High%20school%20English%20class%20with%20students%20reading%20literature%20and%20writing%20essays%2C%20teenagers%20practicing%20advanced%20grammar%20and%20vocabulary%2C%20organized%20classroom%20with%20books%2C%20bright%20clean%20background%2C%20serious%20academic%20atmosphere&width=400&height=300&seq=course-senior-eng1&orientation=landscape',
      description: '強化英文實力與學測應試技巧',
      features: ['進階文法', '學測衝刺', '英文寫作'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '高中',
      title: '高中化學班',
      image: 'https://readdy.ai/api/search-image?query=High%20school%20chemistry%20class%20with%20students%20doing%20advanced%20experiments%2C%20teenagers%20learning%20with%20chemical%20equipment%20and%20periodic%20table%2C%20modern%20laboratory%20classroom%2C%20bright%20clean%20background%2C%20scientific%20educational%20atmosphere&width=400&height=300&seq=course-senior-chem1&orientation=landscape',
      description: '化學原理深化與實驗技能培養',
      features: ['化學原理', '實驗操作', '學測準備'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    },
    {
      level: '高中',
      title: '高中物理班',
      image: 'https://readdy.ai/api/search-image?query=High%20school%20physics%20class%20with%20students%20learning%20mechanics%20and%20electricity%2C%20teenagers%20solving%20physics%20problems%20with%20diagrams%2C%20modern%20classroom%20with%20scientific%20equipment%2C%20bright%20clean%20background%2C%20focused%20learning%20environment&width=400&height=300&seq=course-senior-phy1&orientation=landscape',
      description: '物理概念建立與學測應試訓練',
      features: ['力學電磁', '學測衝刺', '解題技巧'],
      action: '詳情請洽詢',
      buttonText: '立即試聽'
    }
  ];

  const handleTrialClick = () => {
    const element = document.getElementById('contact');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="courses" className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">精彩課程內容</h2>
          <p className="text-xl text-gray-600">
            核心小一到高三，全方位的學習方案
          </p>
        </div>

        {/* 課程卡片 */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
          {courses.map((course, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group cursor-pointer"
            >
              <div className="relative">
                <img
                  src={course.image}
                  alt={course.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute top-3 right-3 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  {course.level}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  {course.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                  {course.description}
                </p>
                <div className="space-y-2 mb-4">
                  {course.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      <span className="text-sm text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
                <div className="text-center mb-4">
                  <p className="text-sm text-gray-500">{course.action}</p>
                </div>
                <button
                  onClick={handleTrialClick}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2.5 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap mb-3"
                >
                  立即試聽
                </button>
                
                {/* LINE QR Code 區塊 */}
                <div className="bg-gradient-to-r from-green-50 to-green-100 rounded-lg p-3 border border-green-200">
                  <div className="flex items-center justify-between">
                    <div className="flex-1">
                      <div className="flex items-center mb-1">
                        <i className="ri-line-fill text-green-600 text-lg mr-1"></i>
                        <span className="text-xs font-semibold text-green-800">加入LINE諮詢</span>
                      </div>
                      <p className="text-xs text-green-700">掃碼了解課程詳情</p>
                    </div>
                    <div className="bg-white p-1.5 rounded-lg shadow-sm">
                      <img 
                        src="https://readdy.ai/api/search-image?query=LINE%20QR%20code%20for%20education%20consultation%20service%2C%20simple%20clean%20QR%20code%20design%20with%20LINE%20logo%2C%20green%20and%20white%20color%20scheme%2C%20professional%20business%20style&width=80&height=80&seq=line-qr-code&orientation=squarish" 
                        alt="LINE QR Code" 
                        className="w-16 h-16 object-contain"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
